<template>
  <div class="restaurant-page">
    <el-tabs v-model="restaurantTab" @tab-click="handleClick">
      <el-tab-pane label="江西省整体" name="JXData">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="restaurantForm" label-width="92px">
            <el-form-item label="指标：">
              <el-radio-group v-model="restaurantForm.index_type" @change="getWholeList">
                <el-radio label="当期网络零售额">当期网络零售额</el-radio>
                <el-radio label="累计网络零售额">累计网络零售额</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth('whole')">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'" @click="wholeTime == '2'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="restaurantForm.startTime" type="month" placeholder="选择日期" class="width-z100 chooseInput"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="restaurantForm.endTime" placeholder="选择日期" type="month" class="width-z100 chooseInput"
                                size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="JXOptions" autoresize class="width-z100 margin-t-30"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="currentSalesTable" stripe height="380" class="float-left border-DEDEDE margin-t-30">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" width="158" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="本地区整体" name="XYData">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="restaurantForm" label-width="92px">
            <el-form-item label="指标：">
              <el-radio-group v-model="restaurantForm.index_type" @change="getLocalAreaList">
                <el-radio label="当期网络零售额">当期网络零售额</el-radio>
                <el-radio label="累计网络零售额">累计网络零售额</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间：">
              <el-col :span="3" style="width: 125px">
                <span :class="wholeTime=='1'?'margin-r-20 cursor-pointer text-1E88E5':'margin-r-20 cursor-pointer'"
                      @click="twelveMonth('whole')">近13个月</span>
                <span :class="wholeTime=='2'?'cursor-pointer text-1E88E5':' cursor-pointer'">月度</span>
              </el-col>
              <!--              <span class="margin-r-10 cursor-pointer">季度</span>-->
              <el-col :span="4">
                <el-date-picker v-model="restaurantForm.startTime" type="month" placeholder="选择日期" class="width-z100 chooseInput"
                                size="small" @change="getLocalAreaList(wholeTime = 2)" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
              <el-col class="text-center" :span="1">-</el-col>
              <el-col :span="4">
                <el-date-picker v-model="restaurantForm.endTime" placeholder="选择日期" type="month" @change="getLocalAreaList(wholeTime = 2)"
                                class="width-z100 chooseInput" size="small" format="yyyy-MM" :picker-options="pickerOptions"
                                value-format="yyyy-MM" :clearable="false"></el-date-picker>
              </el-col>
            </el-form-item>
<!--            <el-form-item class="text-right">-->
<!--              <el-button type="primary" v-on:click="getWholeList">确定</el-button>-->
<!--              &lt;!&ndash;              <el-button>取消</el-button>&ndash;&gt;-->
<!--            </el-form-item>-->
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="LocalAreaOptions" autoresize class="width-z100 margin-t-30"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="LocalAreaTable" stripe height="380" class="float-left border-DEDEDE margin-t-30">
                <el-table-column prop="times" label="时间" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" width="158" align="center"></el-table-column>
                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  export default {
    name: 'restaurant',
    data () {
      return {
        restaurantTab: 'JXData',
        chooseType:'当期网络零售额',//当前选择查询条件
        JXOptions:{},
        LocalAreaOptions: {}, //本地区整体
        restaurantForm: { startTime: '', endTime: '',index_type:'当期网络零售额'},//筛选条件
        LocalAreaTable:[],
        currentSalesTable:[],
        pickerOptions: {
          disabledDate: (time) => {
            // console.log(time.getMonth());
            let nowDate = new Date()
            let day = nowDate.getDate()
            nowDate.setDate(1);
            if (day > 14) {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-1);
              }
            } else {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(10);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else if(nowDate.getMonth()==1){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-2);
              }
            }
            if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
          }
        },
      }
    },
    mounted () {

    },
    created () {
      this.$emit('public_header', true)
      this.twelveMonth()
      // this.oneMonth()
    },
    methods: {
      dateChangebirthday (val) {
        this.wholeTime = 2
        this.restaurantForm.value1 = val
      },
      handleClick(tab, event) {
        if(tab.name == 'JXData'){
          this.getWholeList();
        }
        if(tab.name == 'XYData'){
          this.getLocalAreaList();
        }
      },
      //江西省整体列表
      getWholeList () {
        this.$http.get(this.header + '/catering/wholeCountry', {
          params: {
            index_type: this.restaurantForm.index_type,
            sMonth: this.restaurantForm.startTime,
            eMonth: this.restaurantForm.endTime
          }
        }).then(res => {
          if (res.data.code == 0) {
            let wholeList = {xTime: [], yTotalMoney: [], simple: [],unit:'',legends:''}

            res.data.list.forEach((y, index) => {
              wholeList.xTime.push(y.times)
              let yMoney = {
                value: y.absoulte_value,
                unit: '万元'
              }
              let xSimple = {
                value: y.absoulte_value_yoy,
                unit: '%'
              }
              wholeList.yTotalMoney.push(yMoney)
              wholeList.simple.push(xSimple)
              wholeList.legends = y.index_type
            })

            let Min1 = this.calMin(wholeList.yTotalMoney), Min2 = this.calMin(wholeList.simple),
              Max1 = this.calMax(wholeList.yTotalMoney), Max2 = this.calMax(wholeList.simple)
            //当期网络零售额图表
              this.currentSalesTable = res.data.list.reverse()
              this.JXOptions = {
                title: {//图表标题
                  text: '江西省' + this.chooseType + '变化趋势',
                  left: 'left',
                  textStyle: {
                    color: '#313131',
                    fontSize: 18,
                    fontWeight: 300
                  },
                },
                toolbox: { //图表工具箱
                  feature: {
                    magicType: {show: true, type: ['line', 'bar']},
                    restore: {show: true},
                    saveAsImage: {show: true}
                  }
                },
                tooltip: { // 鼠标悬浮
                  backgroundColor: 'rgba(50,50,50,0.7)',
                  trigger: 'item',
                  formatter: function (e) {
                    return e.name + e.seriesName + '<br/>' + e.value + e.data.unit
                  }
                },
                legend: {//图表说明  horizontal竖着显示vertical横显示
                  orient: 'horizontal',
                  y: 'bottom',
                  // x: 'left',
                  textStyle: {
                    color: '#666',
                    fontSize: 14
                  },
                  data: [wholeList.legends, '同比']
                },
                xAxis: {
                  type: 'category',
                  data: wholeList.xTime,
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  }
                },
                yAxis: [
                  {
                    type: 'value',

                    name: '万元',
                    min: Min1,
                    max: Max1,
                    splitNumber: 5,
                    interval: (Max1 - Min1) / 5,
                    axisLine: {
                      lineStyle: {
                        color: '#666'
                      }
                    },
                  }, {
                    type: 'value',
                    name: '%',
                    min: Min2,
                    max: Max2,
                    splitNumber: 5,
                    interval: (Max2 - Min2) / 5,
                    axisLabel: {
                      formatter: '{value} %'
                    },
                    axisLine: {
                      lineStyle: {
                        color: '#666'
                      }
                    },
                  }],
                series: [{
                  name: wholeList.legends,
                  type: 'bar',
                  barCategoryGap: '60%',
                  itemStyle: {
                    normal: {
                      color: '#7888ed'
                    },
                    emphasis: {
                      color: '#83bff6'
                    }
                  },
                  data:wholeList.yTotalMoney,
                  smooth: true
                }, {
                  name: '同比',
                  type: 'line',
                  yAxisIndex: 1,
                  itemStyle:{
                    normal:{
                      color:'#FB975B'
                    }
                  },
                  data: wholeList.simple
                }]
              }

          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //本地区整体
      getLocalAreaList () {
        this.$http.get(this.header + '/catering/area', {
          params: {
            index_type: this.restaurantForm.index_type,
            sMonth: this.restaurantForm.startTime,
            eMonth: this.restaurantForm.endTime
          }
        }).then(res => {
          if (res.data.code == 0) {
            let wholeList = {xTime: [], yTotalMoney: [], simple: [],unit:'',legends:''}

            res.data.list.forEach((y, index) => {
              wholeList.xTime.push(y.times)
              let yMoney = {
                value: y.absoulte_value,
                unit: y.absoulte_key
              }
              let xSimple = {
                value: y.absoulte_value_yoy,
                unit: '%'
              }
              wholeList.yTotalMoney.push(yMoney)
              wholeList.simple.push(xSimple)
              wholeList.unit = y.absoulte_key
              wholeList.legends = y.index_type
            })

            let Min1 = this.calMin(wholeList.yTotalMoney), Min2 = this.calMin(wholeList.simple),
              Max1 = this.calMax(wholeList.yTotalMoney), Max2 = this.calMax(wholeList.simple)
            //当期网络零售额图表
              this.LocalAreaTable = res.data.list.reverse()
              this.LocalAreaOptions = {
                title: {//图表标题
                  text: '九江市' + this.chooseType + '变化趋势',
                  left: 'left',
                  textStyle: {
                    color: '#313131',
                    fontSize: 18,
                    fontWeight: 300
                  },
                },
                toolbox: { //图表工具箱
                  feature: {
                    magicType: {show: true, type: ['line', 'bar']},
                    restore: {show: true},
                    saveAsImage: {show: true}
                  }
                },
                tooltip: { // 鼠标悬浮
                  backgroundColor: 'rgba(50,50,50,0.7)',
                  trigger: 'item',
                  formatter: function (e) {
                    return e.name + e.seriesName + '<br/>' + e.value + e.data.unit
                  }
                },
                legend: {//图表说明  horizontal竖着显示vertical横显示
                  orient: 'horizontal',
                  y: 'bottom',
                  // x: 'left',
                  textStyle: {
                    color: '#666',
                    fontSize: 14
                  },
                  data: [wholeList.legends, '同比']
                },
                xAxis: {
                  type: 'category',
                  data: wholeList.xTime,
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  }
                },
                yAxis: [
                  {
                    type: 'value',
                    name: wholeList.unit,
                    min: Min1,
                    max: Max1,
                    splitNumber: 5,
                    interval: (Max1 - Min1) / 5,
                    axisLine: {
                      lineStyle: {
                        color: '#666'
                      }
                    },
                  }, {
                    type: 'value',
                    name: '%',
                    min: Min2,
                    max: Max2,
                    splitNumber: 5,
                    interval: (Max2 - Min2) / 5,
                    axisLabel: {
                      formatter: '{value} %'
                    },
                    axisLine: {
                      lineStyle: {
                        color: '#666'
                      }
                    },
                  }],
                series: [{
                  name: wholeList.legends,
                  type: 'bar',
                  barCategoryGap: '60%',
                  itemStyle: {
                    normal: {
                      color: '#7888ed'
                    },
                    emphasis: {
                      color: '#83bff6'
                    }
                  },
                  data:wholeList.yTotalMoney,
                  smooth: true
                }, {
                  name: '同比',
                  type: 'line',
                  yAxisIndex: 1,
                  itemStyle:{
                    normal:{
                      color:'#FB975B'
                    }
                  },
                  data: wholeList.simple
                }]
              }

          } else {
            this.$alert(res.data.msg)
          }

        })
      },

      //选择近13个月
      twelveMonth (val) {
        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (var i = 0; i < 15; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          var m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        this.wholeTime = '1'
        if (day > 14) {
          this.restaurantForm.startTime = dataArr[13]
          this.restaurantForm.endTime = dataArr[1]
        } else {
          this.restaurantForm.startTime = dataArr[14]
          this.restaurantForm.endTime = dataArr[2]
        }
        this.getWholeList()
        this.getLocalAreaList()
      },
      //计算最大值
      calMax (arr) {
        let max = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (max < el1.value) {
              max = el1.value
            }
          }
          // })
        })
        let maxint = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
        let maxval = maxint * 10//让显示的刻度是整数
        return maxval
      },

      //计算最小值
      calMin (arr) {
        let min = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (min > el1.value) {
              min = el1.value
            }
          }
        })
        // })
        let minint = Math.floor(min / 10)
        let minval = minint * 10//让显示的刻度是整数
        return minval
      },
      //计算最大值
      cityCalMax (arr) {
        let max = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (max < el1.value) {
              max = el1.value
            }
          }
          // })
        })
        let maxint = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
        let maxval = maxint * 10//让显示的刻度是整数
        return maxval
      },

      //计算最小值
      cityCalMin (arr) {
        let min = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (min > el1.value) {
              min = el1.value
            }
          }
        })
        // })
        let minint = Math.floor(min / 10)
        let minval = minint * 10//让显示的刻度是整数
        return minval
      },
    }
  }
</script>

<style>

  .restaurant-page {}

  .restaurant-page .el-tabs__item {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    width: 180px;
    height: 45px;
    padding: 0px;
    /*color: #CED4DF;*/
  }

  .restaurant-page .el-tabs__active-bar {
    background-color: transparent;
  }

  .restaurant-page .el-tabs__header {
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 0px;
  }

  .restaurant-page .el-tabs__item.is-active {
    background-color: #3865A5;
    color: white;
  }

  .restaurant-page .el-form-item {
    margin-bottom: 0;
  }

  .restaurant-page .el-radio, .restaurant-page .el-form-item__label {
    color: #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/onlineService/restaurant.vue